export const API_URL = "https://api.comune.rende.cs.it/";
export const API_URL_LARAVEL = "https://api.comune.rende.cs.it/api";


//export const API_URL =  "http://127.0.0.1:8000";
//export const API_URL_LARAVEL = "http://127.0.0.1:8000/api";


